import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {ClickOutsideModule} from 'ng-click-outside';
import {TextMaskModule} from 'angular2-text-mask';
import {NgbModule, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AuthService} from './auth.service';
import {EcvHttpServicesModule} from './ecv-http-services/ecv-http-services.module';
import {environment} from '../../environments/environment';
import {ErrorInterceptor} from '../shared/error.interceptor';
import {GuardsModule} from './guards/guards.module';
import {MockHttpInterceptor} from '../mock/mock-http.interceptor';
import {NgbDateNativeAdapter} from '../shared/ngb-date-native-adapter';
import {WidgetsModule} from '../widgets/widgets.module';
import {RouterModule} from '@angular/router';
import {ValidatorService} from './validator/validator.service';
import {EcvLanguageService} from './ecv-language.service';

export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

/**
 * This module imports most global configuration and all modules that have to be imported to root.
 *
 * Any global config imports (like TranslateModule below) goes here.
 * Every service that is supposed to be a singleton ultimately goes here (directly or through
 * other module, {@see EcvHttpServicesModule} )
 *
 * Avoid putting declarations here, since {@link WidgetsModule}  or {@link SharedModule} are appropriate
 * places for declarations.
 */
@NgModule({
  imports: [
    BrowserModule,
    EcvHttpServicesModule.forRoot(),
    HttpClientModule,
    Ng4LoadingSpinnerModule.forRoot(),
    RouterModule,
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    WidgetsModule,
    GuardsModule,
  ],
  providers: [
    AuthService,
    ValidatorService,
    EcvLanguageService,
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: environment.mockBackend ? MockHttpInterceptor : ErrorInterceptor,
      multi: true
    }
  ],
  exports: [
    BrowserModule,
    ClickOutsideModule,
    EcvHttpServicesModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    Ng4LoadingSpinnerModule,
    NgbModule,
    TextMaskModule,
    TranslateModule,
    WidgetsModule,
  ],
})
export class CoreModule {
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/core.module.ts